import { client } from '@efex-services/config';
import { IApprovePayment, IEnterprisePayments, IGetPayments } from './types';

const API_PAGINATION_VERSION = 2;

const getPayments = async ({
  enterpriseId,
  search,
  page = 1,
  dateFrom,
  dateTo,
  status,
}: IGetPayments): Promise<IEnterprisePayments> => {
  const params = new URLSearchParams();
  params.append('page', `${page}`);
  params.append('_v', `${API_PAGINATION_VERSION}`);
  if (search) params.append('search', search);
  if (dateFrom) params.append('dateFrom', dateFrom);
  if (dateTo) params.append('dateTo', dateTo);
  if (status) params.append('status', status);
  return client.get(
    `/enterprise/${enterpriseId}/payments/?${params.toString()}`
  );
};

const approvePayment = async (values: IApprovePayment) =>
  client.post(`/payments/approve-payment`, values);

const PaymentsSvc = {
  getPayments,
  approvePayment,
};

export default PaymentsSvc;
